import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '@sc/feature-auth-okta';
import { InsurerRouterService } from '@sc/feature-insurer-path-router-system';
import { combineLatest, map, take } from 'rxjs';

export const DossiersSearchGuardCanActivate: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const insurerRouterService = inject(InsurerRouterService);

  return combineLatest([
    authService.userHasClaimsListAccess$(),
    insurerRouterService.getRedirectRoute(),
  ]).pipe(
    take(1),
    map(([hasAccess, redirectUrl]) =>
      hasAccess ? true : router.parseUrl(redirectUrl)
    )
  );
};
